import { type FC } from 'react'
import { observer } from 'mobx-react-lite'
import { Button } from 'shared/ui'
import { type MoreDropdownProps } from 'shared/ui/Actions/Actions'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { type IShortLinkMergeFieldAction } from 'entities/ShortLink/api/types'

type IShortLinkDropdownItemProps = MoreDropdownProps & {
  onAddShortLink: (link: string) => void
  onOpenModal: () => void
  mergeFieldAction?: IShortLinkMergeFieldAction | null
}

export const ShortLinkDropdownItem: FC<IShortLinkDropdownItemProps> = observer(
  ({ onAddShortLink, onCloseMenu, onOpenModal, mergeFieldAction }) => {
    const { shortLinkStore } = useEntitiesContext()
    const onOpenShortenLinkModal = () => {
      onCloseMenu && onCloseMenu()
      onOpenModal && onOpenModal()
      shortLinkStore.onOpenModal({
        onAddLink: onAddShortLink,
        mergeFieldAction,
      })
    }
    return (
      <Button
        typeBtn={'menuItem'}
        text={'Shorten URL'}
        icon={'link'}
        onClick={onOpenShortenLinkModal}
      />
    )
  }
)
